<template>
  <side-bar
  class="left-main-side-bar"
    :sections="sections"
    @open="setSideOpen"
    @close="setSideClosed"
    ref="sidebar"
    noExitButton="true"
    :origin="appName"
  >
    <template :slot="this.$t('frontend_navigation')">
      <div>
        <Navigation />
      </div>
    </template>
    <template :slot="$t('frontend_grooveblog_sidebar_post')">
      <div class="text-sm">
        <ul class="cursor-pointer sidebar-ul text-white absolute p-4">
          <li
            class="mb-2 block-data relative focus:outline-none hover:text-primary"
            @click="sendToListPost"
          >
            {{ $t('frontend_grooveblog_sidebar_post') }}
          </li>
          <li
            class="mb-2 block-data relative focus:outline-none hover:text-primary"
            @click="sendToImportedBlogpostListing"
          >
            {{ $t('frontend_grooveblog_import_listing_metainfo') }}
          </li>
        </ul>
      </div>
    </template>
    <template slot="header">
      <div class="flex flex-col">
        <div>{{ appName }}</div>
      </div>
    </template>
  </side-bar>
</template>

<script>
import SideBar from '@groovepages/gd-ui-kit/components/SideBarNew';
import HomeIcon from '@/assets/images/icons/Home.svg';
import PublishIcon from '@/assets/images/icons/arrow-square-up.svg';
import PostIcon from '@/assets/images/icons/file-invoice.svg';
import CategoryIcon from '@/assets/images/icons/tags.svg';
import ThemeIcon from '@/assets/images/icons/paint-brush.svg';
import NavigationIcon from '@/assets/images/icons/link-alt.svg';
import GeneralIcon from '@/assets/images/icons/settings.svg';
import Navigation from '../pages/navigation/navigation.vue';

export default {
  name: 'SidebarMenu',
  data() {
    return {
      appName: '',
      currentOpenMenuItem: '',
    };
  },
  created() {},
  methods: {
    setSideOpen(side) {
      if (side === 'home') {
        this.sendToBlog();
      } else if (side === this.$t('frontend_builder_publish')) {
        this.sendToHome();
      } else if (side === this.$t('frontend_posts')) {
        this.sendToListPost();
      } else if (side === this.$t('frontend_sidebar_menu_categories')) {
        this.sendToListCategory();
      } else if (side === this.$t('frontend_themes')) {
        this.sendToCustomizeTheme();
      } else if (side === this.$t('frontend_settings')) {
        this.sendToGeneral();
      }
      this.currentOpenMenuItem = side;
    },
    setSideClosed() {
      this.currentOpenMenuItem = '';
    },
    sendToBlog() {
      this.$router.push({ name: 'blog' });
    },
    sendToHome() {
      this.$router.push({ name: 'home' });
    },
    sendToListPost() {
      this.$router.push({ name: 'list_post' });
    },
    sendToImportedBlogpostListing() {
      this.$router.push({ name: 'list_imports' });
    },
    sendToListCategory() {
      this.$router.push({ name: 'list_category' });
    },
    sendToCustomizeTheme() {
      this.$router.push({ name: 'theme' });
    },
    sendToNavigation() {
      this.$router.push({ name: 'navigation' });
    },
    sendToGeneral() {
      this.$router.push({ name: 'general' });
    },
  },
  computed: {
    // Used to return brandData value from store.
    supBrandName() {
      return this.$store.getters.appName;
    },
    sections() {
      return [
        { name: 'home', icon: HomeIcon, doNotOpen: 1 },
        { name: this.$t('frontend_builder_publish'), icon: PublishIcon, doNotOpen: 1 },
        { name: this.$t('frontend_grooveblog_sidebar_post'), icon: PostIcon },
        { name: this.$t('frontend_sidebar_menu_categories'), icon: CategoryIcon, doNotOpen: 1 },
        { name: this.$t('frontend_themes'), icon: ThemeIcon, doNotOpen: 1 },
        { name: this.$t('frontend_navigation'), icon: NavigationIcon },
        { name: this.$t('frontend_settings'), icon: GeneralIcon, doNotOpen: 1 },
      ];
    },
  },
  components: {
    SideBar,
    Navigation,
  },
};
</script>
<style lang="scss">
.sidebar-ul {
  padding : 1rem !important;
}

</style>
